import IconComponent from "icons/IconComponent";

import ShoppingBagIcon from "./shopping-bag.svg";

export default (ShoppingBagIcon as any) as IconComponent;
